import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const ServicePointSinterklaas: FC<SvgIconProps> = ({ viewBox = '0 0 254 204', ...props }) => (
  <SvgIcon viewBox={viewBox} fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#servicepoint_sinterklaas_paint0_clip)">
      <path
        d="m100.83 54.589-2.274 3.274s-9.919 3.712-12.605 9.388c0 0-3.307 3.929 0 38.64l49.803 1.31-3.926-39.95s-1.24-10.698-7.647-12.226c0 0-7.026-1.31-11.366-1.965L100.83 54.59Z"
        fill="#E5E5E5"
      />
      <path d="m109.302 62.23.827 9.605 2.066-.436-.826-9.606-2.067.437Z" fill="#C9C9C9" />
      <path d="M100.623 51.096v3.493l9.506 7.422 3.306-8.732-12.812-2.183Z" fill="#DEA07B" />
      <path
        d="m85.33 99.997 5.167-1.092s-1.447-3.711-1.447-7.64c0-3.057-.413-8.296-.413-8.296s.413-8.95 2.067-13.099c1.653-4.148 10.745-9.169 10.745-9.169l-3.1-2.62s-5.166 2.184-8.472 4.803c0 0-4.546 2.184-4.96 8.514-.207 0-1.24 12.226.413 28.599Z"
        fill="#C9C9C9"
      />
      <path
        d="m100.623 54.589 9.506 7.422-2.48 4.148-9.3-8.296 2.274-3.274ZM95.663 75.546l.207 22.267 2.273-.218"
        fill="#8E8E8E"
      />
      <path
        d="m115.295 53.716 8.473 1.31s3.927.654 6.2 5.457c0 0 2.273 4.148 2.48 13.317l-1.034.436s-1.446-12.007-5.786-14.408c0 0-5.993-2.62-10.746-3.493l.413-2.62Z"
        fill="#F4F4F4"
      />
      <path
        d="m123.148 68.56 4.34 23.36-1.86.436M113.435 53.28l-3.306 8.731 3.72 2.183 1.446-10.478-1.86-.437Z"
        fill="#8E8E8E"
      />
      <path
        d="M119.635 39.307c.413 8.078-3.72 15.063-10.539 15.5-6.82.437-12.606-6.55-13.226-14.627-.413-8.295 1.653-14.844 10.746-14.844 8.886 0 12.606 5.894 13.019 13.971Z"
        fill="#F1BE96"
      />
      <path
        d="M103.309 37.998c-1.653-.219-.413 5.675-1.446 6.33-1.034.874-1.447-3.71-3.1-3.71-2.48 0-2.067 6.548-2.893-.438-.827-8.077 1.653-14.844 10.746-14.844 5.993 0 9.712 2.62 11.572 6.986 0 0 1.86 4.802-2.893 5.894-.206 0-4.546 1.091-11.986-.218Z"
        fill="#28211E"
      />
      <path
        opacity=".5"
        d="m87.19 203.692 25.419-5.239-43.19-22.704L44 180.988l43.19 22.704Z"
        fill="url(#servicepoint_sinterklaas_paint0_linear)"
      />
      <path d="m112.609 126.412 75.841-14.408L145.26 89.3l-75.842 14.408 43.191 22.704Z" fill="#FDDE84" />
      <path d="M112.609 126.412v72.041l-43.19-22.704v-72.041l43.19 22.704Z" fill="#C39000" />
      <path d="M112.609 126.412v72.041l75.841-14.408v-72.042l-75.841 14.409Z" fill="#FCCE09" />
      <path d="m111.989 124.884 79.148-15.063-45.05-23.578-79.355 15.064 45.257 23.577Z" fill="#996A0D" />
      <path d="M111.989 124.884v4.584l-45.257-23.795v-4.366l45.257 23.577Z" fill="#634509" />
      <path d="M111.989 124.884v4.584l79.148-15.063v-4.584l-79.148 15.063Z" fill="#BC9361" />
      <path
        opacity=".5"
        d="m105.583 123.356 12.605-2.62-15.085-7.859-12.606 2.62 15.086 7.859Z"
        fill="url(#servicepoint_sinterklaas_paint1_linear)"
      />
      <path d="m118.188 110.258 14.673-2.62-15.086-7.86-14.672 2.62 15.085 7.86Z" fill="#FDDE84" />
      <path d="M118.188 110.257v10.697l-15.085-8.077v-10.479l15.085 7.859Z" fill="#C39000" />
      <path d="M118.188 110.258v10.697l14.673-2.838v-10.479l-14.673 2.62Z" fill="#FCCE09" />
      <path d="m114.055 44.11 1.034 3.93-1.654-.218" fill="#DEA07B" />
      <path
        d="m123.148 160.25 7.646-1.529-.413.655-7.233 1.31v-.436ZM123.148 159.158l8.473-1.747-.413.655-8.06 1.528v-.436ZM123.148 161.341l6.82-1.528-.414.655-6.406 1.31v-.437ZM179.978 149.334l-7.646 1.528.413-.655 7.233-1.528v.655ZM179.978 150.426l-8.473 1.746.413-.655 8.06-1.746v.655ZM173.572 148.897l6.406-1.309v.655l-6.82 1.309.414-.655ZM130.588 160.468l3.719-5.894s4.133-.874 4.547-.874c.413 0 .413 0 .206.437-.206.437-.62 1.092-.826 1.528-.207.218-.413.655.413.437.827-.218 5.993-1.31 5.993-1.31-.413.873-2.066 3.275-5.166 3.711-2.48.655-8.886 1.965-8.886 1.965ZM151.46 153.482l-2.067 3.056-5.166 1.092 2.066-3.275 5.167-.873ZM159.106 151.954l-2.067 3.056-5.166 1.092 2.067-3.056 5.166-1.092ZM160.759 151.517s-.413.655-.62.874c-.62 1.091 0 1.964 2.067 1.528 2.479-.437 8.472-1.747 8.472-1.747l2.067-3.056-11.986 2.401Z"
        fill="#D40511"
      />
      <path
        d="m133.068 151.517-1.86 2.838s9.506-1.965 9.919-1.965c.413 0 .413 0 .207.437-.207.437-.62 1.092-.827 1.528-.207.218-.413.655.413.437.827-.219 4.133-.873 4.133-.873s.62-1.092 1.24-1.965c.827-1.092 0-3.275-2.686-2.62-2.48.655-10.539 2.183-10.539 2.183ZM159.519 151.08l-12.812 2.62 3.513-5.458 5.166-1.091-2.066 3.275 2.479-.655 1.86-3.057 5.373-1.091-3.513 5.457ZM170.265 144.095l-3.513 5.676-5.58 1.091 3.513-5.457 5.58-1.31Z"
        fill="#D40511"
      />
      <path d="m114.882 70.089.62 6.112 3.513.655 2.48-1.965-.62-5.894-5.993 1.092Z" fill="#C9C9C9" />
      <path
        d="M120.875 70.089v-1.092l-5.993 1.092.207 1.091M110.542 64.85c.343 0 .62-.294.62-.656 0-.361-.277-.655-.62-.655-.342 0-.62.294-.62.655 0 .362.278.655.62.655ZM110.749 67.687c.342 0 .62-.293.62-.655 0-.361-.278-.655-.62-.655-.343 0-.62.294-.62.655 0 .362.277.655.62.655ZM110.955 70.743c.343 0 .62-.293.62-.654 0-.362-.277-.655-.62-.655-.342 0-.62.293-.62.654 0 .362.278.655.62.655Z"
        fill="#8E8E8E"
      />
      <path
        d="M95.25 24.9c.207-3.057.207-6.55.62-8.733 1.446-5.458 3.72-12.225 4.133-12.444 1.033 0 7.439 9.388 7.853 10.697.826 1.747-7.233 19.211-12.606 10.48Z"
        fill="#90191C"
      />
      <path
        d="M94.63 24.68c.207-1.09.62-5.457 1.447-8.513-.207 2.183-.207 5.676 0 5.894.206.437.62.655 2.273-2.401.62-1.092 7.646-18.993 8.679-19.211 1.447-.437 10.953 17.246 11.986 20.302 0 1.31-.207 10.26-.207 11.352 0 0-3.513 3.057-8.679 3.493-5.993.437-13.846-1.746-13.846-1.746-.413-1.092-1.86-8.95-1.653-9.17Z"
        fill="#EB2028"
      />
      <path
        d="M107.856 2.414c1.446 3.493 3.72 13.753 4.133 20.302.207 3.711.413 12.88.413 12.007h-1.86s0-7.64-.413-12.007c-.827-8.514-3.1-17.683-3.306-19.21-.414-1.31 1.033-1.092 1.033-1.092Z"
        fill="#FCD811"
      />
      <path
        d="M116.949 20.315s-9.093 3.711-19.013 2.62c-.206 0-1.24 2.183-1.24 2.183s13.02 1.528 21.079-2.838l-.826-1.965Z"
        fill="#FCD811"
      />
      <path
        d="M111.773 30.016a.428.428 0 0 0-.397-.454.422.422 0 0 0-.429.418c-.01.241.168.444.396.454.228.01.42-.177.43-.418ZM111.579 26.68a.427.427 0 0 0-.396-.453.424.424 0 0 0-.43.418.428.428 0 0 0 .397.454c.228.01.42-.177.429-.418ZM111.311 23.295a.428.428 0 0 0-.396-.454.424.424 0 0 0-.43.418.428.428 0 0 0 .396.454.423.423 0 0 0 .43-.418ZM111.112 19.658a.428.428 0 0 0-.396-.454.423.423 0 0 0-.43.418.428.428 0 0 0 .396.454.423.423 0 0 0 .43-.418ZM110.714 16.486a.427.427 0 0 0-.396-.454.424.424 0 0 0-.43.418.428.428 0 0 0 .397.454c.228.01.42-.177.429-.418ZM110.153 13.522a.428.428 0 0 0-.396-.454.423.423 0 0 0-.43.419.428.428 0 0 0 .396.454.423.423 0 0 0 .43-.419ZM109.564 10.746a.428.428 0 0 0-.396-.454.423.423 0 0 0-.43.419.428.428 0 0 0 .396.454.423.423 0 0 0 .43-.419ZM108.918 7.888a.427.427 0 0 0-.396-.454.424.424 0 0 0-.43.418.428.428 0 0 0 .397.454c.228.01.42-.177.429-.418ZM108.298 23.76a.429.429 0 0 0-.397-.454.422.422 0 0 0-.429.419c-.01.24.168.444.396.454.228.01.42-.178.43-.419ZM105.579 23.893a.428.428 0 0 0-.397-.454.422.422 0 0 0-.429.418.427.427 0 0 0 .396.454c.228.01.42-.177.43-.418ZM102.27 24.145a.428.428 0 0 0-.396-.453.424.424 0 0 0-.43.418.428.428 0 0 0 .396.454.423.423 0 0 0 .43-.419ZM99.385 24.096a.428.428 0 0 0-.396-.454.423.423 0 0 0-.43.42c-.009.24.169.443.397.453.228.01.42-.178.43-.419ZM114.014 22.534a.428.428 0 0 0-.396-.453.423.423 0 0 0-.43.418.428.428 0 0 0 .396.454c.228.01.42-.178.43-.419ZM116.415 21.703a.428.428 0 0 0-.396-.454.423.423 0 0 0-.43.419.428.428 0 0 0 .396.454.423.423 0 0 0 .43-.419ZM107.785 2.823a.428.428 0 0 0-.396-.454.423.423 0 0 0-.43.419.428.428 0 0 0 .396.454.423.423 0 0 0 .43-.419Z"
        fill="#F4A621"
      />
      <path
        d="M97.11 33.631c-.207-1.091-.413-3.492-.62-5.676-.207-1.091-.207-2.183-.207-2.837 0-1.092 0-1.747.413-1.965 1.654-.873 2.894-4.148 3.514-5.458v-.218c.413-.873 2.066-5.458 3.719-9.387 1.24-3.057 2.274-5.676 2.687-6.55 0-.218.207-.218.413-.218h.413c.207.218.62.437 4.134 7.204 2.066 3.711 4.133 7.86 5.373 10.042.413.873.826 1.528.826 1.747v.218c.207 1.528-.207 9.169-.413 11.57 0 .437-.207.655-.62.437-.207 0-.413-.437-.413-.655.206-2.183.413-9.387.413-11.134-.207-.218-.413-.873-.827-1.528-1.24-2.183-3.306-6.33-5.166-9.824-1.033-1.964-1.86-3.493-2.687-4.802-.413-.655-.826-1.31-1.033-1.529-.413 1.31-1.446 3.493-2.273 5.676-1.653 3.93-3.306 8.514-3.72 9.388-.413.655-.826 1.964-1.446 3.056-.827 1.31-1.654 2.183-2.273 2.838 0 .218 0 1.31.206 3.93.207 1.964.413 4.147.62 5.239 0 .436-.207.655-.413.655h-.207c-.206.218-.413.218-.413-.219Z"
        fill="#FCD811"
      />
      <path
        d="M111.923 33.228a.428.428 0 0 0-.397-.454.422.422 0 0 0-.429.418c-.01.241.168.445.396.454.228.01.42-.177.43-.418Z"
        fill="#F4A621"
      />
      <path
        d="M118.602 30.575v1.747c-4.547 4.802-14.053 4.584-22.526 1.528 0-.218-.206-.873-.206-1.965 6.199 2.401 11.366 2.838 15.292 2.183 3.307-.655 5.993-2.401 7.44-3.493Z"
        fill="#FCD811"
      />
      <path
        d="M108.289 5.06a.427.427 0 0 0-.396-.454.424.424 0 0 0-.43.419.428.428 0 0 0 .397.454c.228.01.42-.178.429-.419Z"
        fill="#F4A621"
      />
      <path
        opacity=".5"
        d="m137.614 109.602 9.299-1.964-15.499-8.078-9.299 1.965 15.499 8.077Z"
        fill="url(#servicepoint_sinterklaas_paint2_linear)"
      />
      <path d="m146.913 81.659 27.279-5.021-15.499-8.296-27.279 5.24 15.499 8.077Z" fill="#FDDE84" />
      <path opacity=".4" d="m140.094 78.166 27.485-5.24-2.687-1.31-27.278 5.24 2.48 1.31Z" fill="#AA7B33" />
      <path d="M146.913 81.659v25.978l-15.499-8.077V73.582l15.499 8.077Z" fill="#C39000" />
      <path opacity=".4" d="M140.094 78.166v5.676l-2.48-1.528v-5.458l2.48 1.31Z" fill="#AA7B33" />
      <path d="M146.913 81.659v25.978l27.279-5.239v-25.76l-27.279 5.02Z" fill="#FCCE09" />
      <path d="m140.094 104.145-2.274-1.31-.206-25.979 2.48 1.31v25.979Z" fill="#AF0527" />
      <path d="m164.892 71.617-27.278 5.24 2.48 1.309 27.485-5.24-2.687-1.31Z" fill="#D2002E" />
      <path d="m158.899 105.454 2.893-.655.207-25.978-2.893.655-.207 25.978Z" fill="#AF0527" />
      <path d="m147.12 70.525 14.879 8.296-2.893.655-14.879-8.296 2.893-.655Z" fill="#D2002E" />
      <path
        d="M151.046 74.455s-5.786-.437-7.233-.437c-1.446 0-2.273.873-2.273 1.746 0 .874.827 1.529 1.447 1.965.826.437 3.926 2.62 3.926 2.62l6.2-4.366-2.067-1.528Z"
        fill="#D2002E"
      />
      <path
        d="M153.319 75.765s-2.893.655-4.339.873c-1.447.218-2.894.655-2.48 2.401.206 1.747 2.066 1.092 3.1.219.826-.655 3.719-3.493 3.719-3.493Z"
        fill="#AF0527"
      />
      <path
        d="M151.873 74.236s1.653-4.584 2.066-5.676c.414-1.091 1.033-2.183 2.067-1.746 1.033.437 5.579 3.056 5.579 3.056l-7.852 5.676-1.86-1.31Z"
        fill="#D2002E"
      />
      <path
        d="M153.733 75.546s4.339-4.148 4.959-4.803c.62-.655 2.687-1.746 2.893-.436 0 1.528-1.033 1.965-2.273 2.62-1.446.873-5.579 2.62-5.579 2.62ZM144.64 74.455l6.613.218.826.873-4.753 1.092 3.513-1.092-2.273-.218 1.654-.219-5.58-.654ZM152.699 74.018l1.86-4.584-1.24 4.147.827-1.091-.413 1.091 1.24-1.746-.827 1.965 3.513-3.057-3.926 3.93-1.034-.655Z"
        fill="#AF0527"
      />
      <path
        d="M153.939 74.236c.62.437.62 1.092 0 1.528-.62.437-1.86.437-2.48 0-.62-.436-.62-1.091 0-1.528.62-.436 1.654-.436 2.48 0Z"
        fill="#D2002E"
      />
      <path
        d="M154.146 75.546c-.62.437-1.86.437-2.48 0-.413-.218-.62-.655-.413-1.091-.414.436-.207.873.206 1.31.62.436 1.86.436 2.48 0 .207-.219.413-.219.413-.437 0 0-.206 0-.206.218Z"
        fill="#AF0527"
      />
      <path d="m111.782 117.461-2.273-1.091-.207-10.697 2.687 1.31-.207 10.478Z" fill="#0E248C" />
      <path d="m123.768 102.835-14.466 2.838 2.687 1.31 14.259-2.838-2.48-1.31Z" fill="#4B67BF" />
      <path d="m124.388 119.644 2.893-.436v-10.479l-3.1.437.207 10.478Z" fill="#0E248C" />
      <path d="m112.816 100.652 14.465 8.077-3.1.437-14.259-8.078 2.894-.436Z" fill="#4B67BF" />
      <path
        d="M116.329 104.145s-5.787-.437-7.233-.437c-1.447 0-2.273.873-2.273 1.747 0 .873.826 1.528 1.446 1.964.827.437 3.926 2.62 3.926 2.62l6.2-4.366-2.066-1.528Z"
        fill="#4B67BF"
      />
      <path
        d="M118.602 105.455s-2.893.655-4.34.873c-1.446.218-2.893.655-2.48 2.401.207 1.747 2.067 1.092 3.1.219.827-.655 3.72-3.493 3.72-3.493Z"
        fill="#0E248C"
      />
      <path
        d="M116.948 103.927s1.654-4.585 2.067-5.676c.413-1.092 1.033-2.184 2.067-1.747 1.033.655 5.579 3.056 5.579 3.056l-7.646 5.676-2.067-1.309Z"
        fill="#4B67BF"
      />
      <path
        d="M119.015 105.236s4.34-4.147 4.96-4.802c.62-.655 2.686-1.747 2.893-.437 0 1.528-1.033 1.965-2.273 2.62-1.447.873-5.58 2.619-5.58 2.619ZM109.716 104.145l6.819.218.62.873-4.546 1.092 3.513-1.092h-2.273l1.653-.436-5.786-.655ZM117.775 103.708l1.86-4.584-1.24 4.148.827-1.092-.414 1.092 1.24-1.747-.826 1.965 3.513-3.056-3.927 3.929-1.033-.655Z"
        fill="#0E248C"
      />
      <path
        d="M119.222 103.927c.62.436.62 1.091 0 1.528-.62.436-1.86.436-2.48 0-.62-.437-.62-1.092 0-1.528.62-.437 1.653-.437 2.48 0Z"
        fill="#4B67BF"
      />
      <path
        d="M119.222 105.236c-.62.437-1.86.437-2.48 0-.413-.218-.62-.655-.413-1.091-.414.436-.207.873.206 1.31.62.436 1.86.436 2.48 0 .207-.219.413-.219.413-.437l-.206.218Z"
        fill="#0E248C"
      />
    </g>
    <defs>
      <linearGradient
        id="servicepoint_sinterklaas_paint0_linear"
        x1="74.557"
        y1="197.491"
        x2="82.734"
        y2="182.299"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".269" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset=".511" stopColor="#181816" stopOpacity=".364" />
        <stop offset=".817" stopColor="#080807" stopOpacity=".825" />
        <stop offset=".933" />
      </linearGradient>
      <linearGradient
        id="servicepoint_sinterklaas_paint1_linear"
        x1="102.525"
        y1="121.892"
        x2="106.535"
        y2="114.441"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".269" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset=".511" stopColor="#181816" stopOpacity=".364" />
        <stop offset=".817" stopColor="#080807" stopOpacity=".825" />
        <stop offset=".933" />
      </linearGradient>
      <linearGradient
        id="servicepoint_sinterklaas_paint2_linear"
        x1="133.172"
        y1="107.345"
        x2="136.118"
        y2="101.871"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".269" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset=".511" stopColor="#181816" stopOpacity=".364" />
        <stop offset=".817" stopColor="#080807" stopOpacity=".825" />
        <stop offset=".933" />
      </linearGradient>
      <clipPath id="servicepoint_sinterklaas_paint0_clip">
        <path fill="#fff" transform="translate(0 .44)" d="M0 0h254v203.126H0z" />
      </clipPath>
    </defs>
  </SvgIcon>
)
